import { render } from "./DetalleDocumentos.vue?vue&type=template&id=90fd56ce"
import script from "./DetalleDocumentos.vue?vue&type=script&lang=js"
export * from "./DetalleDocumentos.vue?vue&type=script&lang=js"

import "./DetalleDocumentos.vue?vue&type=style&index=0&id=90fd56ce&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__